"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _Card = _interopRequireDefault(require("./Card"));

exports["default"] = _Card["default"];